import {combineReducers} from "redux";
import productsReducer from "./products/productsReducer";
import uiReducer from "./ui/uiReducer";
import settingsReducer from "./settings/settingsReducer";
import settingsTempReducer from "./settings/settingsReducer";
import spacesReducer from "./spaces/spacesReducer";
import productFamiliesReducer from "../productFamilies/productFamiliesReducer";
import productTypesReducer from "../productTypes/productTypesReducer";

export interface VendorState {
    products,
    spaces,
    ui,
    settings,
    tempSettings,
    productFamilies,
    productTypes
}

export interface AuthState {
    auth
}

const vendorState: VendorState = {
    products: productsReducer,
    spaces: spacesReducer,
    ui: uiReducer,
    settings: settingsReducer,
    tempSettings: settingsTempReducer,
    productFamilies: productFamiliesReducer,
    productTypes: productTypesReducer,
}

const fullState = {
    ...vendorState
}

const rootReducer = combineReducers(fullState);

export default rootReducer